<template>
    <div id="telematicsReadingCreate" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <template v-if="assetReadingTab != undefined">
            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="VendorForm">
                <div class='form-row row-cols-md-4 row-cols-1'>
                    <div class="col form-group">
                        <label class="control-label require" for="Vehicle">Vehicle</label>
                        <v-select v-model="vehicle" name="vehicle"
                                    label="text" :filterable="false" :options="vehicleArr"
                                    @search="onSearchVehicle" @input="onAssetChange"
                                    placeholder="Select Vehicle" class="custom-ci-auto-search" :disabled="disableVehicleField">
                            <template slot="no-options">
                                Search Vehicle...
                            </template>
                            <template slot="option" slot-scope="option">
                                <div class="d-center">
                                    {{ option.text }}
                                </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center">
                                    {{ option.text }}
                                </div>
                            </template>
                        </v-select>
                        <div class="field-error">{{ vehicleerror }}</div>
                    </div>
                    <div class="col form-group">
                        <label class="control-label" for="name">Actual:</label>
                        <div class="custome-radiobtn">
                            <div class="form-check form-check-inline">
                                <label class="boolean optional radio-custom" for="misc1_eligible"> Yes
                                    <input type="radio" v-model="isAccurate" :value="1" id="misc1_eligible" name="isAccurate1">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="form-check form-check-inline">
                                <label class="boolean optional radio-custom" for="misc2_eligible"> No
                                    <input type="radio" v-model="isAccurate" :value="0" id="misc2_eligible" name="isAccurate1">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div class="field-error"></div>
                    </div>
                    <div class="col form-group" v-if="canAddMeterChange === true">
                        <label class="control-label" for="name">Meter Change:</label>
                        <div class="custome-radiobtn">
                            <div class="form-check form-check-inline">
                                <label class="boolean optional radio-custom" for="misc3_eligible"> Yes
                                    <input type="radio" v-model="meter" :value="1" id="misc3_eligible" name="meterChange">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="form-check form-check-inline">
                                <label class="boolean optional radio-custom" for="misc4_eligible"> No
                                    <input type="radio" v-model="meter" :value="0" id="misc4_eligible" name="meterChange">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div class="field-error"></div>
                    </div>
                    <div class="col form-group">
                        <label class="control-label require" for="reading_date">Reading / Billing Date:</label>
                        <div class="input-group">
                            <date-picker placeholder="MM/DD/YYYY HH:MM:SS" id="reading_date" name="reading_date" v-model="reading_date" :config="optionsDate"></date-picker>
                            <label for="reading_date" class="fp-calendar input-calender-icon"></label>
                        </div>
                        <div class="field-error">{{ reading_date_error }}</div>
                    </div>
                    <!-- <div class="col form-group">
                        <label class="control-label" for="name">Odometer:</label>
                        <input type="text" class="form-control" @keypress="isAmountCheck($event)" v-model="reading" id="reading" placeholder="Enter Reading" name="name">
                        <div class="field-error">{{ readingerrors }}</div>
                    </div>
                    <div class="col form-group">
                        <label class="control-label" for="reeferHr">Reefer:</label>
                        <input type="text" class="form-control" @keypress="isAmountCheck($event)" v-model="reeferHr" id="reeferHr" placeholder="Enter Reefer Hours" name="reeferHr">
                        <div class="field-error">{{ reeferHrError }}</div>
                    </div>

                    <div class="col form-group">
                        <label class="control-label" for="reeferSbHr">Reefer StandBy:</label>
                        <input type="text" class="form-control" @keypress="isAmountCheck($event)" v-model="reeferSbHr" id="reeferSHr" placeholder="Enter Reefer Standby Hours" name="reeferSbHr">
                        <div class="field-error">{{ reeferSbHrError }}</div>
                    </div>
                    <div class="col form-group">
                        <label class="control-label " for="apuHr">Engine Hours:</label>
                        <input type="text" class="form-control" @keypress="isAmountCheck($event)" v-model="apuHr" id="apuHr" placeholder="Enter Engine Hours" name="apuHr">
                        <div class="field-error">{{ apuHrError }}</div>
                    </div> -->
                    <template v-if="sectionTypeArr && sectionTypeArr.length">
                        <template v-for="(sec,sval) in sectionTypeArr">
                            <div class="col form-group col-md-2" :key="sval">
                                <template v-if="sec.section_code.toLowerCase() == 'dist'">
                                    <label class="control-label required" for="notes">Odometer:</label>
                                    <input type="text" class="form-control" v-model="sec.reading" :id="'readingVal'+sec.section_code" autocomplete="off" :placeholder="'Odometer'" name="readingVal" @keypress="isAmountCheck($event)">
                                </template>
                                <template v-else>
                                    <label class="control-label required" for="notes">{{sec.sectionName}}:</label>
                                    <input type="text" class="form-control" v-model="sec.reading" :id="'readingVal'+sec.section_code" autocomplete="off" :placeholder="sec.sectionName" name="readingVal" @keypress="isAmountCheck($event)">
                                </template>
                                <div class="field-error">{{ sec.reading_error }}</div>
                            </div>
                        </template>
                    </template>
                </div>
                <div class="field-error">{{ common_error_msg }}</div>
                <div class="form-row">
                    <div class="col form-group">
                        <div class="alert alert-warning hide" id="alertError">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <strong id="errorMsg" class="field-error"></strong>
                        </div>
                    </div>
                </div>
                <div class="btn-groups">
                    <button type="submit" id="createVendorBtn" class="btn btn-primary" v-on:click.prevent="AddReading" >
                        <i class="fp-save"> </i>  Save
                    </button>
                    <button type="submit" id="createAndContinueVendorBtn" class="btn btn-tertiary" v-on:click.prevent="AddReading(flag='Save and Continue')" >
                        <i class="fp-save-continue"> </i>  Save and Continue
                    </button>
                    <button type="button" id="cancelVendorBtn" class="btn btn-tertiary" v-on:click.prevent="$parent.AddReadingFlag = false" >
                        <i class="fp-close"> </i>  Cancel
                    </button>
                </div>
            </form>
            <div class="modal fade invoice-modal update-reading-modal" id="readingModal" ref="readingModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true"  >
                <div class="modal-dialog" role="document">
                    <div class="modal-content additionalSize">
                        <div class="modal-header">
                            <h5 class="modal-title">Warning {{ model_data.sectionName }} Reading</h5>
                        </div>
                        <div class="modal-body">
                            <form id="importFile" class="addinspectionForm telematics-reading-form">
                                <div class="form-row row-cols-md-3 row-cols-1">
                                    <input class="form-control" id="unitNum" type="hidden">
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Current:Actual Reading</label>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name"> {{ model_data.reading }} {{ model_data.section_code }} </label>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name"> {{ model_data.readingDate }}  </label>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Previous:Actual Reading  </label>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">{{ model_data.prev_reading }} {{ model_data.section_code }}</label>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name"> {{ model_data.prev_reading_date }}</label>
                                    </div>
                                </div>
                                <div style=" color: red; ">
                                    <label class="control-label" for="name">{{ model_data.warning }}</label>
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer btm-action-btn-fl">
                            Override Warning and Continue ?
                            <button type="button" class="btn btn-tertiary" id="yes" v-on:click.prevent="yesOverride(model_data)" > Yes</button>
                            <button type="button" class="btn btn-tertiary"  v-on:click.prevent="noOverride(model_data)"> No</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div id="page-content-wrapper" class="admin-content-area" v-else>
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vendorHeader">Add Telematics Reading</span>
                    <router-link type="submit" class="btn btn-secondary pull-right" v-bind:to="'/telematics-reading/list'" >
                        <i class="fp-back"> </i> Back
                    </router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content telematics-reading-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="VendorForm">
                                <div class='form-row row-cols-md-4 row-cols-1'>
                                    <div class="col form-group">
                                        <label class="control-label require" for="Vehicle">Vehicle</label>
                                        <v-select v-model="vehicle" name="vehicle"
                                            label="text" :filterable="false" :options="vehicleArr"
                                            @search="onSearchVehicle" @input="onAssetChange"
                                            placeholder="Select Vehicle" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Vehicle...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ vehicleerror }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="reading_date">Reading / Billing Date:</label>
                                        <date-picker placeholder="MM/DD/YYYY HH:MM:SS" id="reading_date" name="reading_date" v-model="reading_date" :config="optionsDate"></date-picker>
                                        <div class="field-error">{{ reading_date_error }}</div>
                                    </div>
                                </div>
                                <hr class="light-hr"/>
                                <div class='form-row row-cols-md-1 row-cols-1'>

                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="name">Odometer:</label>
                                        <input type="text" class="form-control" @keypress="isAmountCheck($event)" v-model="reading" id="reading" placeholder="Enter Reading" name="name">
                                        <div class="field-error">{{ readingerrors }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="reeferHr">Reefer:</label>
                                        <input type="text" class="form-control" @keypress="isAmountCheck($event)" v-model="reeferHr" id="reeferHr" placeholder="Enter Reefer Hours" name="reeferHr">
                                        <div class="field-error">{{ reeferHrError }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="reeferSbHr">Reefer StandBy:</label>
                                        <input type="text" class="form-control" @keypress="isAmountCheck($event)" v-model="reeferSbHr" id="reeferSHr" placeholder="Enter Reefer Standby Hours" name="reeferSbHr">
                                        <div class="field-error">{{ reeferSbHrError }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="apuHr">Engine Hours:</label>
                                        <input type="text" class="form-control" @keypress="isAmountCheck($event)" v-model="apuHr" id="apuHr" placeholder="Enter Engine Hours" name="apuHr">
                                        <div class="field-error">{{ apuHrError }}</div>
                                    </div> -->
                                    <template v-if="sectionTypeArr && sectionTypeArr.length">
                                        <template v-for="(sec,sval) in sectionTypeArr">
                                            <div class="col form-group" :key="sval">
                                                <template v-if="sec.section_code.toLowerCase() == 'dist'">
                                                    <div class="form-row row-cols-md-4 row-cols-1">
                                                        <div class="col">
                                                            <label class="control-label required" for="notes">Odometer:</label>
                                                            <input type="text" class="form-control" v-model="sec.reading" :id="'readingVal'+sec.section_code" autocomplete="off" :placeholder="'Odometer'" name="readingVal" @keypress="isAmountCheck($event)">
                                                        </div>
                                                        <div class="col">
                                                            <div class=" form-group">
                                                                <label class="control-label" for="name">Actual:</label>
                                                                <div class="custome-radiobtn">
                                                                    <div class="form-check form-check-inline">
                                                                        <label class="boolean optional radio-custom" for="misc1_eligible"> Yes
                                                                            <input type="radio" v-model="sec.actual_change" :value="1" :id="'misc1_eligible'+sec.section_code" :name="'isAccurate'+sec.section_code">
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div class="form-check form-check-inline">
                                                                        <label class="boolean optional radio-custom" for="misc2_eligible"> No
                                                                            <input type="radio" v-model="sec.actual_change" :value="0" :id="'misc2_eligible'+sec.section_code" :name="'isAccurate'+sec.section_code">
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div class="field-error"></div>
                                                            </div>

                                                        </div>
                                                        <div v-if="canAddMeterChange === true" class="col">
                                                            <div class=" form-group">
                                                                <label class="control-label" for="name">Meter Change:</label>
                                                                <div class="custome-radiobtn">
                                                                    <div class="form-check form-check-inline">
                                                                        <label class="boolean optional radio-custom" for="misc3_eligible"> Yes
                                                                            <input type="radio" v-model="sec.meter_change" :value="1" :id="'misc3_eligible'+sec.section_code" :name="'meterChange'+sec.section_code">
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div class="form-check form-check-inline">
                                                                        <label class="boolean optional radio-custom" for="misc4_eligible"> No
                                                                            <input type="radio" v-model="sec.meter_change" :value="0" :id="'misc4_eligible'+sec.section_code" :name="'meterChange'+sec.section_code">
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div class="field-error"></div>
                                                            </div>
                                                        </div>
                                                        <div class="col">
                                                            <div class=" form-group">
                                                                <label class="control-label" for="name">Is Billing:</label>
                                                                <div class="custome-radiobtn">
                                                                    <div class="form-check form-check-inline">
                                                                        <label class="boolean optional radio-custom" for="misc5_eligible"> Yes
                                                                            <input type="radio" v-model="sec.is_billing" :value="1" :id="'misc5_eligible'+sec.section_code" :name="'isBilling'+sec.section_code">
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div class="form-check form-check-inline">
                                                                        <label class="boolean optional radio-custom" for="misc6_eligible"> No
                                                                            <input type="radio" v-model="sec.is_billing" :value="0" :id="'misc5_eligible'+sec.section_code" :name="'isBilling'+sec.section_code">
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div class="field-error"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="form-row row-cols-md-4 row-cols-1">
                                                        <div class="col">
                                                            <label class="control-label required" for="notes">{{sec.sectionName}}:</label>
                                                            <input type="text" class="form-control" v-model="sec.reading" :id="'readingVal'+sec.section_code" autocomplete="off" :placeholder="sec.sectionName" name="readingVal" @keypress="isAmountCheck($event)">
                                                        </div>
                                                            <div class="col">
                                                                <label class="control-label" for="name">Actual:</label>
                                                                <div class="custome-radiobtn">
                                                                    <div class="form-check form-check-inline">
                                                                        <label class="boolean optional radio-custom" for="misc1_eligible"> Yes
                                                                            <input type="radio" v-model="sec.actual_change" :value="1" :id="'misc1_eligible'+sec.section_code" :name="'isAccurate'+sec.section_code">
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div class="form-check form-check-inline">
                                                                        <label class="boolean optional radio-custom" for="misc2_eligible"> No
                                                                            <input type="radio" v-model="sec.actual_change" :value="0" :id="'misc2_eligible'+sec.section_code" :name="'isAccurate'+sec.section_code">
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div class="field-error"></div>
                                                            </div>
                                                            <div v-if="canAddMeterChange === true" class="col">
                                                                <label class="control-label" for="name">Meter Change:</label>
                                                                <div class="field-error">{{ sec.reading_error }}</div><div class="custome-radiobtn">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="boolean optional radio-custom" for="misc3_eligible"> Yes
                                                                        <input type="radio" v-model="sec.meter_change" :value="1" :id="'misc4_eligible'+sec.section_code" :name="'meterChange'+sec.section_code">
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="boolean optional radio-custom" for="misc4_eligible"> No
                                                                        <input type="radio" v-model="sec.meter_change" :value="0" :id="'misc4_eligible'+sec.section_code" :name="'meterChange'+sec.section_code">
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div class="field-error"></div>
                                                        </div>
                                                        <div class="col">
                                                                <label class="control-label" for="name">Is Billing:</label>
                                                                <div class="field-error">{{ sec.reading_error }}</div><div class="custome-radiobtn">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="boolean optional radio-custom" for="misc5_eligible"> Yes
                                                                        <input type="radio" v-model="sec.is_billing" :value="1" :id="'misc5_eligible'+sec.section_code" :name="'isBilling'+sec.section_code">
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="boolean optional radio-custom" for="misc6_eligible"> No
                                                                        <input type="radio" v-model="sec.is_billing" :value="0" :id="'misc5_eligible'+sec.section_code" :name="'isBilling'+sec.section_code">
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div class="field-error"></div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </template>
                                    </template>
                                </div>
                                <div class="field-error">{{ common_error_msg }}</div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createVendorBtn" class="btn btn-primary" v-on:click.prevent="AddReading" >
                                        <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueVendorBtn" class="btn btn-tertiary" v-on:click.prevent="AddReading(flag='Save and Continue')" >
                                        <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <router-link type="submit" class="btn btn-tertiary" v-bind:to="'/telematics-reading/list'" >
                                        <i class="fp-close"> </i> Cancel
                                    </router-link>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
                <div class="modal fade invoice-modal update-reading-modal" id="readingModal" ref="readingModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true"  >
                    <div class="modal-dialog" role="document">
                        <div class="modal-content additionalSize">
                            <div class="modal-header">
                                <h5 class="modal-title">Warning {{ model_data.sectionName }} Reading</h5>
                            </div>
                            <div class="modal-body">
                                <form id="importFile" class="addinspectionForm telematics-reading-form">
                                    <div class="form-row row-cols-md-3 row-cols-1">
                                        <input class="form-control" id="unitNum" type="hidden">
                                        <div class="col form-group">
                                            <label class="control-label" for="name">Current:Actual Reading</label>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label" for="name"> {{ model_data.reading }} {{ model_data.section_code }} </label>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label" for="name"> {{ model_data.readingDate }}  </label>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label" for="name">Previous:Actual Reading  </label>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label" for="name">{{ model_data.prev_reading }} {{ model_data.section_code }}</label>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label" for="name"> {{ model_data.prev_reading_date }}</label>
                                        </div>
                                    </div>
                                    <div style=" color: red; ">
                                        <label class="control-label" for="name">{{ model_data.warning }}</label>
                                    </div>
                                </form>
                            </div>
                            <div class="modal-footer btm-action-btn-fl">
                                Override Warning and Continue ?
                                <button type="button" class="btn btn-tertiary" id="yes" v-on:click.prevent="yesOverride(model_data)" > Yes</button>
                                <button type="button" class="btn btn-tertiary"  v-on:click.prevent="noOverride(model_data)"> No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>

import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';


import moment from 'moment';
import timezone from 'moment-timezone';

export default {
  name: "telematicsReadingCreate",
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Create Telematics Reading | " +process.env.COPYRIGHT_NAME
  },

  mixins:[commonMixins,contractMixins],
  props: {
    assetReadingTab: {
        type: String,
        required: false,
        default: undefined
    },
    assetId: {
        type: Number,
        required: false,
        default: undefined
    },
    unitNo: {
        type: String,
        required: false,
        default: undefined
    },
    assetName: {
        type: String,
        required: false,
        default: undefined
    },
    locationCode: {
        type: String,
        required: false,
        default: undefined
    },
    assetTypeId: {
        type: Number,
        required: false,
        default: undefined
    }
  },
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    canAddMeterChange: "",
    vehicleArr:[],
    vehicle:null,
    currentreading : '',
    previousreading: '',
    prev_reading_date:'',
    currentreadingDate:'',
    sectionname:'',
    // fromDate:"",
    // toDate:"",
    reeferHr:"",
    reeferSbHr:"",
    apuHr:"",
    // fromDateError:"",
    // toDateError:"",
    apuHrError:"",
    reeferSbHrError:"",
    reeferHrError:"",
    // sectionArr:[],
    // section:"",
    // sectionerror:"",
    // vomArr:[],
    // vom:"",
    // vomerror:"",
    loading:false,
    readingerrors: '',
    vehicleerror:"",
    meter:0,
    isAccurate:1,
    reading:"",
    reading_date:"",
    meter_change:0,
    actual_change:0,
    is_billing:0,
    minDatetime:"",
    optionsDate: {
        format: 'MM/DD/YYYY hh:mm:ss a',
        useCurrent: false,
        toolbarPlacement:'bottom',
        widgetPositioning: {
            horizontal: 'auto',
            vertical: 'bottom'
        },
        showClose: true,
    },
    optionsToDate: {
        format: 'MM/DD/YYYY hh:mm:ss a',
        useCurrent: false,
        toolbarPlacement:'bottom',
            widgetPositioning: {
            horizontal: 'auto',
            vertical: 'bottom'
            },
    },
    reading_date_error:"",
    disableVehicleField:false,
    sectionTypeArr:[],
    form_data:[],
    model_data: {},
    common_error_msg:"",
    stringArray:[],
  }),
    watch: {

        //check permission change
        permissions: function (permissions) {
          // console.log(permissions);
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_odometer_reading') {
                      self.cantAccessPage = true;
                    }
                    if(permissions[i].name == 'add_meter_change'){
                      self.canAddMeterChange = true;
                    }
                }
            }

        },

    },

  created: function() {

  },
  mounted: function() {

        var self = this;

        self.localtimezone = moment.tz.guess();
        var localTime = moment().toISOString(); // store localTime
        var proposedDate = localTime;
        // var conDate = moment.tz(dateToday, 'UTC').format('YYYY-MM-DDThh:mm:ssz ');
        self.minDatetime = proposedDate;
        // if from Asset View Page Meters Tab
        if (self.assetReadingTab != undefined) {

            var vehicleName = "";
            if (self.unitNo != undefined && self.unitNo != "") {
                vehicleName += self.unitNo;
            }

            if (self.assetName != undefined && self.assetName != "") {
                vehicleName = vehicleName + " | " + self.assetName;
            }

            if (self.locationCode != undefined && self.locationCode != "") {
                vehicleName = vehicleName + " | " + self.locationCode;
            }

            self.vehicle = { text: vehicleName,value:self.assetId};
            if (self.assetTypeId != undefined && self.assetTypeId != null && self.assetTypeId != "") {
                self.vehicle.vehicle_type_id = self.assetTypeId;
                self.onAssetChange();//reading inputs as per section
            }
            self.disableVehicleField = true;


        }else{
            var path = window.location.pathname;
            var segments = path.split("/");

            self.getPermissions();
            //load vendor tax types

            if (segments[3]) {

                // this.vendorId= segments[3];

    //            $("#createVendorBtn").val("Update");
    //            $("#vendorHeader").text("Edit Vendor");
    //            $("#createAndContinueVendorBtn").hide();
    //            self.loadVendor();


            }
            var userObj = JSON.parse(localStorage.getItem("user_obj"));
            if(userObj != null){
                var dateTimeFormat = userObj["date_format"] + " " + userObj["time_format"];
                if(dateTimeFormat != null){
                    console.log(dateTimeFormat);
                    //set date time format in optionsDate format of date picker
                    self.reading_date = moment().format('MM/DD/YYYY hh:mm:ss a');
                }
            }
            // this.reading_date = moment().format('MM/DD/YYYY hh:mm:ss A');

            //self.loadFieldData(['section','vom']);
        }
  },
  methods: {

    onSearchVehicle(search, loading) {
        var self = this;
        if (search.length > 3) {
            loading(true);
            self.searchField(loading, search, 'vehicle');
        }
    },

    searchVehicle(search, loading ,flag) {
        var self = this;
        $.ajax({
                url: process.env.ROOT_API + "/search_vehicle",
                type: "post",
                crossDomain: true,
                headers: this.ajxHeaders,
                data: {
                    search: search,
                    flag:flag
                },
                dataType: "json",
                success: function (data) {

                    if (data.status == "success") {

                        loading(false);
                        if ( flag == 'vehicle') {
                            self.vehicleArr = data.content;
                        } else if ( flag == 'section') {
                            self.sectionArr = data.content;
                        } else {
                            self.vomArr = data.content;
                        }

                    }
                },

                error: function (jqXHR, exception) {

                    //self.CheckBtn = 'Check';
                    if (jqXHR.status == 0) {
                        self.error = "Remote server cannot be reached";
                    } else {
                        self.error = jqXHR.responseJSON.message;
                    }
                }
            });
    },

    AddReading(flag) {

        var self = this;
        var error = false;

        // self.fromDateError = "";
        self.toDateError = "";
        self.reeferHrError = "";
        self.apuHrError = "";
        self.reeferSbHrError = "";
        self.reeferHrError = "";
        self.readingerrors = "";
        self.vehicleerror = "";
        self.vomerror = "";
        self.reading_date_error = "";
        self.sectionerror = "";
        self.common_error_msg = "";

        /*if (!self.reading || self.reading == '') {
            self.readingerrors = 'Reading Required';
            error = true;
        }*/
        // if(self.vom == null){
        //     self.vom = '';
        // }
        // if(self.vom == '' || !self.vom.value ){
        //     self.vomerror = 'VOM Required';
        //     error = true;
        // }
        // if(self.section == null){
        //     self.section = '';
        // }
        // if(self.section == '' || !self.section.value){
        //     self.sectionerror = 'Section Required';
        //     error = true;
        // }
        if ( self.vehicle == null ) {
            self.vehicle = null;
            error = true;
        }
        if ( self.vehicle == null|| !self.vehicle.value ) {
            self.vehicleerror = "Vehicle Required";
            error = true;
        }
        if ( !self.reading_date || self.reading_date == null || self.reading_date == "" ) {
            self.reading_date_error = "Reading / Billing Date Required.";
            error = true;
        }
        if (self.vehicle != null && self.vehicle.value && self.sectionTypeArr.length < 1) {
            self.common_error_msg = "Section Type for Vehicle Required.";
            error = true;
        }
        var valmeterAdded = 0;
        if (self.sectionTypeArr && self.sectionTypeArr.length > 0) {
            var valNotAdded = 0;
            for(var i = 0;i < self.sectionTypeArr.length;i++) {
                if (!self.sectionTypeArr[i].reading || self.sectionTypeArr[i].reading == '') {
                    valNotAdded++;
                }
                if (self.sectionTypeArr[i].meter_change == 1) {
                    valmeterAdded++;
                }
            }
            if (valNotAdded == self.sectionTypeArr.length) {
                self.common_error_msg = "Reading for Section Type Required.";
                error = true;
            }
        }
        if (self.sectionTypeArr && self.sectionTypeArr.length > 0) {
            for(var i = 0;i < self.sectionTypeArr.length;i++) {
                self.sectionTypeArr[i].flag = "";
                }
        }
        if (!error) {
            if(self.stringArray.length > 0){
                self.sectionTypeArr = self.stringArray;
            }
            var fields = {
                isAccurate:self.isAccurate,
                meter:self.meter,
                vehicle:self.vehicle.value,
                reading_date:self.reading_date,
                reading_arr:JSON.stringify(self.sectionTypeArr)
            };
            if (valmeterAdded != 0) {
                // error = true;
                self.$swal({
                    title: 'You have selected meter change "YES". Are you sure?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.callStoreRead(fields,flag);
                    } else {
                        return;
                    }
                });
            }else{
                self.callStoreRead(fields,flag);
            }
        }else{
            self.errorValidationFocus();
        }

    },
    callStoreRead(fields,flag){
        console.log(fields);
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        self.loading = true;
        $.ajax({
                url: process.env.ROOT_API + "/reading/add",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    console.log(data.content);

                    // if (flag == "Save and Continue") {

                    //     $("#createAndContinueVendorBtn").val("Save and Continue");
                    //     $("#createVendorBtn").prop("disabled", false);
                    //     $("#createAndContinueVendorBtn").prop("disabled", false);
                    //     $("#cancelVendorBtn").prop("disabled",false);

                    // } else {

                    //     $("#createVendorBtn").val("Save");
                    //     $("#createVendorBtn").prop("disabled", false);
                    //     $("#createAndContinueVendorBtn").prop("disabled", false);
                    //     $("#cancelVendorBtn").prop("disabled",false);

                    // }
                    // if (data.code == 201){
                    //     self.$swal('',data.message,'info');
                    //     return;
                    // }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {
                            //if from Asset View Page Meters Tab
                            if (self.assetReadingTab == undefined) {
                                self.vehicle = null;
                            }
                            self.vom = "";
                            self.section = "";
                            self.reading = "";
                            // self.fromDate = "";
                            // self.toDate = "";
                            self.reeferHr = "";
                            self.reeferSbHr = "";
                            self.apuHr = "";
                            self.sectionTypeArr = [];
                            self.common_error_msg = "";

                        } else {
                            if (self.assetReadingTab != undefined) {
                                self.$parent.showOdometerReadingList();
                            }else{
                                self.$router.push("/telematics-reading/list");
                            }
                        }
                    }else if(data.status == "warning"){
                            self.form_data = data.content;

                        if(self.form_data.length > 0) {
                            self.model_data = self.form_data[0];
                            console.log(self.model_data);
                            $("#readingModal").modal('show');
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVendorBtn").val("Update");
                        $("#createVendorBtn").prop("disabled", false);
                        $("#cancelVendorBtn").prop("disabled",false);
                    }
                    //else {
                        // if (flag == "Save and Continue") {

                        //     // $("#createAndContinueVendorBtn").val("Save and Continue");
                        //     // $("#createVendorBtn").prop("disabled", false);
                        //     // $("#createAndContinueVendorBtn").prop("disabled", false);
                        //     // $("#cancelVendorBtn").prop("disabled",false);

                        // }else{

                        //     // $("#createVendorBtn").val("Save");
                        //     // $("#createVendorBtn").prop("disabled", false);
                        //     // $("#createAndContinueVendorBtn").prop("disabled", false);
                        //     // $("#cancelVendorBtn").prop("disabled",false);

                        // }
                    //}
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");
                            //EventBus.$emit("logged-in", true, "", "");
                            self.$router.push("/");
                        }
                        $("#errorMsg").html(jqXHR.responseJSON.message);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            });
    },
    noOverride(model_data) {
        console.log("here noOverride");
        var self = this;
        // model_data.flag = "skip";
        // self.stringArray.push(model_data);
        // self.form_data.splice(0, 1);
        // if(self.form_data.length > 0) {
        //     console.log("here noOverride if....");
        //     self.model_data = self.form_data[0];
        //     console.log(self.model_data);
        //     $("#readingModal").modal('show');
        // }else{
            $('#readingModal').modal('hide');
            // self.AddReading();
        // }


    },
    yesOverride(model_data){
        var self = this;
        model_data.flag = "stor";

        self.stringArray.push(model_data);
        self.form_data.splice(0, 1);
        if(self.form_data.length > 0) {
            console.log("here yesOverride if....");
            self.model_data = self.form_data[0];
            console.log(self.model_data);
            $("#readingModal").modal('show');
        }else{
            console.log("here yesOverride else....");
            $('#readingModal').modal('hide');
            self.AddReading();
        }

    },
    validEmail: function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },
    onAssetChange() {
        var self = this;
        if (self.vehicle != null && self.vehicle.value){
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/section-by-truck-type/fetch",
                type: "GET",
                headers: this.ajxHeaders,
                data: {
                    vehicle_type_id:self.vehicle.vehicle_type_id,
                    vehicle_id:self.vehicle.value
                },
                dataType : "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.sectionTypeArr = data.content;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'asset-wise-section')
                }
            });
        }
    },
  }
};
</script>
<style scoped>
.additionalSize{
    width: 137% !important;
    margin-left: -30% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/telematicsReading/TelematicsReadingCreate.vue